import React, { useRef, useState } from "react";
import { Grid, Typography } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";

import ButtonComponent from "../../../../components/common/button/Button";
import { downloadPMExcelTemplateEndpoint, uploadPriceMemoMaintenanceEndpoint } from "../../../../common/endpoints";

const Upload = ({setLoading}) => {
  const fileInputRef = useRef(null);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const { instance } = useMsal();
  const procurementGroup = localStorage.getItem("procurementDivisionType");
  const userEmail = localStorage.getItem("data");
  const userName = localStorage.getItem("userName");
  const Cdregion = localStorage.getItem("CDRegion");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setUploadedFileName(file.name);
      setSelectedFile(file);
    }
  };

  const handleSubmitUpload = async (event) => {
    event.preventDefault();
    if (!selectedFile) return;
    setLoading(true);
    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    try {
      const tokenResponse = await instance?.acquireTokenSilent(tokenRequest);
      const accessToken = tokenResponse?.accessToken;

      // build URL with required params
      const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/${uploadPriceMemoMaintenanceEndpoint}/${procurementGroup.toLowerCase()}/uploadPriceMemo?userName=${cleanUsername(userName)}&userId=${userEmail}${procurementGroup.toLowerCase() === 'packaging' ? `&region=${Cdregion}` : ''}`;

      // use FormData for file upload + a JSON payload field
      const fd = new FormData();
      fd.append('file', selectedFile);
      fd.append('payload', JSON.stringify());

      const response = await axios.post(url, fd, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          // do not set Content-Type manually so browser sets multipart boundary
        },
        withCredentials: true,
      });

      if (response.status >= 200 && response.status < 300) {
        // handle success (toast, clear state, etc.)
        toast.success(response?.data, {
            position: "top-right",
            autoClose: 3000,
        });
        setUploadedFileName('');
        setSelectedFile(null);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = async (event) => {
    event.preventDefault();
    setLoading(true);
    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    try {
      const tokenResponse = await instance?.acquireTokenSilent(tokenRequest);
      const accessToken = tokenResponse?.accessToken;

      const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/${downloadPMExcelTemplateEndpoint}/${procurementGroup.toLowerCase()}/excelTemplate?userName=${userEmail}${procurementGroup.toLowerCase() === 'packaging' ? `&region=${Cdregion}` : ''}`;
      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            withCredentials: true,
          },
          responseType: "blob", // Important for Excel download
        }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          `${procurementGroup.toLowerCase()}-price-memo-maintenance.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        setLoading(false);
        toast.success("Template downloaded successfully!", {
            position: "top-right",
            autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error downloading contract tracking report:", error);
    }
  };

  return (
    <>
      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "20px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "500" }}>
          Excel Upload
        </Typography>
        <Grid
          item
          xs={6}
          mt={2}
          sx={{
            display: "flex",
            flexDirection: "row",
            "& .MuiFormLabel-root": { fontSize: "14px" },
            "& .MuiInputBase-root>Input": { height: "80% !important" },
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".xls,.xlsx,.csv"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <ButtonComponent
            label="Download Template"
            bgColor="#000"
            color="#fff"
            onClick={handleDownloadTemplate}
          />
          <p style={{ marginLeft: "10px" }}></p>
          <ButtonComponent
            label="Select file"
            bgColor="#000"
            color="#fff"
            onClick={handleUploadClick}
          />
          {uploadedFileName ? (
            <>
              <Typography
                variant="body2"
                sx={{ ml: 2, alignSelf: "center", mr: 2, maxWidth: "200px" }}
              >
                {uploadedFileName}
              </Typography>
              <ButtonComponent
                label="Upload"
                bgColor="#000"
                color="#fff"
                onClick={handleSubmitUpload}
              />
            </>
          ) : null}
        </Grid>
      </div>
    </>
  );
};

export default Upload;
